import N8nInputNumber from './InputNumber.vue';

export default N8nInputNumber;
export { N8nInputNumber };
export type * from './InputNumber.types';
